import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'millisecondsToDate'
})
export class MillisecondsToDatePipe implements PipeTransform {

  transform(value: number): Date {
    if(value){
      return new Date(value);
    }
    
  }

}
